import React from 'react'

export default function Dropdownicon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 12 8" fill="none"><path d="M11 1L6 6L1 1" stroke="currentColor" strokeWidth="2"></path></svg>
    )
}
